// extracted by mini-css-extract-plugin
module.exports = {"data":"style_data__16tvs"};